"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AllowsPayload = void 0;
exports.AllowsPayload = {
    POST: true,
    PUT: true,
    DELETE: true,
};
//# sourceMappingURL=allows_payload.js.map